import withAPIAction from 'helpers/withAPIAction'
import {
  ListReq,
  DetailReq,
  CreateReq,
  UpdateReq,
  DeleteReq,
  MasterProductReq,
  ImportProductReq,
  RequestProductReq,
  UpdateRequestStatusReq,
  UpdateProductStatusReq,
  GetAllProductReq,
  UpdateProductPriceReq,
  BomDetailReq,
  UpdateProductBomReq,
  ImportFileProductCheckingReq,
  ImportFileProductReq,
  ApproveDetailReq,
} from './types'
import {
  getListAction,
  createAction,
  updateAction,
  getDetailAction,
  deleteAction,
  getMasterProductAction,
  importProductAction,
  getRequestProductsAction,
  updateRequestStatusAction,
  updateProductStatusAction,
  getAllProductListAction,
  updateProductPriceAction,
  getBomDetailAction,
  updateProductBomAction,
  checkingProductFromFileAction,
  createProductFromFileAction,
  getLogRequestProductsAction,
  getApproveProductDetailAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { CreateMapping } from 'Store/common/common.types'
import { getRequestString } from 'helpers/format'

export const productListAPI = (data: ListReq, token: string) => {
  return withAPIAction<ListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.productList}`,
    data,
    token,
  })(getListAction)
}

export const createProductAPI = (data: CreateMapping<CreateReq>, token: string) => {
  return withAPIAction<CreateMapping<CreateReq>>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createProduct,
    data,
    token,
  })(createAction)
}

export const updateProductAPI = (data: UpdateReq, token: string) => {
  return withAPIAction<UpdateReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.updateProduct,
    data,
    token,
  })(updateAction)
}

export const deleteProductAPI = (data: DeleteReq, token: string) => {
  return withAPIAction<DeleteReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.deleteProduct,
    data,
    token,
  })(deleteAction)
}

export const getProductDetailAPI = (data: DetailReq, token: string) => {
  const endPoint = APIPath.getProductByID.replace(':id', data.id.toString())
  return withAPIAction<DetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
  })(getDetailAction)
}

export const getBomDetailAPI = (data: BomDetailReq, token: string) => {
  return withAPIAction<BomDetailReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.getBomByProductID,
    data,
    token,
  })(getBomDetailAction)
}

export const getMasterProductAPI = (data: MasterProductReq, token: string, xmid: string) => {
  return withAPIAction<MasterProductReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.getMasterProduct,
    data,
    token,
    xmid,
  })(getMasterProductAction)
}

export const importProductAPI = (data: ImportProductReq, token: string, xmid: string) => {
  return withAPIAction<ImportProductReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.importProducts,
    data,
    token,
    xmid,
  })(importProductAction)
}

export const getLogProductsAPI = (data: RequestProductReq, token: string) => {
  return withAPIAction<RequestProductReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.getRequestProduct,
    data,
    token,
  })(getLogRequestProductsAction)
}

export const requestProductsAPI = (data: RequestProductReq, token: string) => {
  return withAPIAction<RequestProductReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.getRequestProducts,
    data,
    token,
  })(getRequestProductsAction)
}

export const updateRequestStatusAPI = (data: UpdateRequestStatusReq, token: string) => {
  return withAPIAction<UpdateRequestStatusReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.updateRequestProductsStatus,
    data,
    token,
  })(updateRequestStatusAction)
}

export const updateProductStatusAPI = (data: UpdateProductStatusReq, token: string) => {
  return withAPIAction<UpdateProductStatusReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.updateProductStatus,
    data,
    token,
  })(updateProductStatusAction)
}

export const getAllProductAPI = (data: GetAllProductReq, token: string, xmid: string) => {
  return withAPIAction<GetAllProductReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.getAllProductList}?${getRequestString(data)}`,
    data,
    //token,
    //xmid,
  })(getAllProductListAction)
}

export const updateProductPriceAPI = (data: UpdateProductPriceReq, token: string) => {
  return withAPIAction<UpdateProductPriceReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.updateProductPrice,
    data,
    token,
  })(updateProductPriceAction)
}

export const updateProductBomAPI = (data: UpdateProductBomReq, token: string) => {
  return withAPIAction<UpdateProductBomReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.updateProductBom,
    data,
    token,
  })(updateProductBomAction)
}

export const checkingProductFromFileAPI = (
  data: ImportFileProductCheckingReq,
  token: string,
  xmid: string,
) => {
  return withAPIAction<ImportFileProductCheckingReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.checkImportProductsFromFile,
    data,
    token,
    xmid,
  })(checkingProductFromFileAction)
}

export const createProductFromFileAPI = (data: ImportFileProductReq, token: string, xmid: string) => {
  return withAPIAction<ImportFileProductReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.createImportProductsFromFile,
    data,
    token,
    xmid,
  })(createProductFromFileAction)
}

export const getApproveProductDetailAPI = (data: ApproveDetailReq, token: string, xmid: string) => {
  return withAPIAction<ApproveDetailReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.getRequestProductDetail,
    data,
    token,
    xmid,
  })(getApproveProductDetailAction)
}
